import { loadListByShortcut, loadLists } from 'isotope-client/modules/valueList/services/valueListActions'

export const loadListFoByShortcut = (shortcut, idLanguage = undefined) => dispatch => loadListByShortcut(shortcut, idLanguage, false)(dispatch)

export const loadListBoByShortcut = (shortcut) => dispatch => loadListByShortcut(shortcut)(dispatch)

export const loadAllLists = () => dispatch => loadLists()(dispatch)
